/**
 * BackgroundField — subtle immersion layer.
 *
 * Removed per user brief: the static SVG concentric intelligence rings
 * around the orb. Everything visible around the orb must animate/react
 * (the WebGL membrane/filament/halo layers cover that need).
 *
 * Retained: radial vignette + faint grid texture + soft cyan floor glow.
 * All are non-directional ambient environment — not rings/waves.
 *
 * Sits at z=0 behind all UI. Pointer-events: none.
 */

export function BackgroundField() {
    return (
        <div
            data-testid="background-field"
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 z-0 overflow-hidden"
        >
            {/* Faint grid — ambient texture, not concentric */}
            <div
                className="absolute inset-0 opacity-[0.05]"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
                    backgroundSize: "56px 56px",
                    maskImage:
                        "radial-gradient(ellipse at center, black 20%, transparent 75%)",
                    WebkitMaskImage:
                        "radial-gradient(ellipse at center, black 20%, transparent 75%)",
                }}
            />

            {/* Vignette */}
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "radial-gradient(ellipse at center, transparent 20%, rgba(0,0,0,0.85) 100%)",
                }}
            />

            {/* Soft cyan glow reflected beneath the orb */}
            <div
                className="absolute left-1/2 top-[62%] -translate-x-1/2 -translate-y-1/2"
                style={{
                    width: 900,
                    height: 380,
                    background:
                        "radial-gradient(ellipse at center, rgba(0,229,255,0.05) 0%, transparent 65%)",
                    filter: "blur(24px)",
                }}
            />
        </div>
    );
}

export default BackgroundField;
